export type typeTypoModel = {
  startIndex: number;
  endIndex: number;
  correctSpelling: string;
};

export type typeTemplateTypoModel = {
  width: number;
  top: number;
  left: number;
};

export const DPA_WORD_PATTERN_LEFT = '['; // DPA动态词包在广告文案中的模式, 只支持单个字符
export const DPA_WORD_PATTERN_RIGHT = ']'; // DPA动态词包在广告文案中的模式, 只支持单个字符

export const checkType = {
  realTimePrecheck: 'realTimePrecheck',
  submitPrecheck: 'store',
};

export const realTimePrecheckSplicingMap = {
  // language_mismatch模型
  material_language_mismatch: {
    ownKey: 'material_language_mismatch',
    // 模型检测的素材类型
    modelType: ['adsTexts'],
    // 预校验类型
    checkType: checkType.realTimePrecheck,
    // 模型命中的hitcountry是否是一个对象
    hitcountryisObject: true,
    countryHitCode: '21100141',
    occupy: '{targeting_country}',
    replaceKey: 'module_text_real_check_fail_target_country_tips',
    link: {
      key: 'module_text_real_check_fail_target_country_tips_learn_more',
      url: 'https://ads.tiktok.com/help/article?aid=9552',
    },
  },
  material_skin_exposure_chest: {
    ownKey: 'material_skin_exposure_chest',
    modelType: ['videos', 'images'],
    checkType: checkType.submitPrecheck,
    hitcountryisObject: false,
    countryHitCode: '20800009',
    occupy: '{TargetRegion}',
    replaceKey: 'module_text_real_check_fail_skin_exposure_tips',
    link: {
      key: 'module_text_real_check_fail_target_country_tips_learn_more',
      url: 'https://ads.tiktok.com/help/article?aid=9552',
    },
  },
  material_skin_exposure_leg: {
    ownKey: 'material_skin_exposure_leg',
    // 对应模型校验的类型
    modelType: ['videos', 'images'],
    checkType: checkType.submitPrecheck,
    hitcountryisObject: false,
    countryHitCode: '20800010',
    occupy: '{TargetRegion}',
    replaceKey: 'module_text_real_check_fail_skin_exposure_tips',
    link: {
      key: 'module_text_real_check_fail_target_country_tips_learn_more',
      url: 'https://ads.tiktok.com/help/article?aid=9552',
    },
  },
};
